import {configure as configureUikit, Lang} from '@gravity-ui/uikit';
import {configure as configureCommon} from '@yandex-data-ui/common';
import {configure as configureNavigation} from '@yandex-data-ui/navigation';
import {setConfig as configureCloudComponents} from '@yandex-data-ui/cloud-components';

import {sdk} from '~ui/services/sdk';

const lang = document.documentElement.lang as Lang;

configureUikit({lang});
configureCommon({lang});
configureNavigation({lang});
configureCloudComponents({lang});
sdk.setLang(lang);
